module.exports = __webpack_public_path__ + "assets/img/f9c529c1770e16cd87b1c6a0d334ba00.png";